import React, { useState } from 'react'

export default function SummaryModal({data, handleClose, handleProceed, saving = false}) {
    const [truncateReceiver, setTruncateReceiver] = useState(true)

    const truncateText = (text) => {
        if (text && text.length > 100) {
            if (truncateReceiver) return text.substring(0, 100) + '...'
            if (!truncateReceiver) return text
        } else {
            return text
        }
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 cu-width-input">
                <h3 className='text-center'>Post Summary</h3>
                <p className='text-center'>This post is now ready, please confirm the following details: </p>

                <div>
                    <p>
                        <b>Sending Post: </b> {data.sender}
                    </p>
                    <p>
                        <b>Receiving Post: </b>
                        { truncateText(data.receiver) }
                        {truncateText(data.receiver).length <= 103 && 
                            data.receiver.length > 100 &&
                            <span 
                                className='text-blue' 
                                onClick={() => { setTruncateReceiver(false) } }
                                style={{cursor: 'pointer', color: 'blue'}}
                            > 
                                {' show more'}
                            </span>
                        }
                        {truncateText(data.receiver).length > 103 &&
                            <span 
                                className='text-blue' 
                                onClick={() => { setTruncateReceiver(true) }} 
                                style={{cursor: 'pointer', color: 'blue'}}
                            > 
                                {'  show less'}
                            </span>
                        }
                    </p>
                </div>

                <div className="pt-3 text-center">
                    <button onClick={handleProceed} type="button" className="btn btn-primary mr-2" disabled={saving}>
                    {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Confirm
                    </button>

                    <button onClick={handleClose} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                        Cancel
                    </button>
                </div>
                <small class='mt-3 text-center'>Please confirm, or go back and adjust your audience settings</small>
            </div>
        </div>
    </div>
  )
}
